
const __default__ = {
  props: {
    open: {type: Boolean, default: false},
    horizontal: {type: Boolean, default: false},
    keepAlive: {type: Boolean, default: false},
    opacity: {type: Boolean, default: true},
    duration: {type: Number, default: 200}
  },
  computed: {
    css_duration() {
      return `${this.duration}ms`
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "629fad5d-css_duration": (_ctx.css_duration)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__